<header class="sticky top-0 z-40 border-b border-slate-200 bg-white/80 backdrop-blur">
  <div class="flex items-center justify-between gap-3 px-4 py-3 sm:px-6">
    <div class="flex items-center gap-3">
      <button
        mat-icon-button
        type="button"
        aria-label="Navigation umschalten"
        class="navbar-toggler inline-flex items-center justify-center rounded-full bg-transparent text-slate-600 shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 lg:hidden"
        (click)="sidebarToggle()"
      >
        <fa-icon [icon]="icons.menu"></fa-icon>
      </button>
      @if (titleService.getTitle() !== 'Anmeldung') {
        <button
          mat-mini-fab
          color="primary"
          type="button"
          aria-label="Zurück"
          class="shadow-sm"
          (click)="location.back()"
        >
          <fa-icon [icon]="icons.back"></fa-icon>
        </button>
      }
      <div class="flex flex-col">
        <span class="text-lg font-semibold text-slate-900 leading-tight">{{ titleService.getTitle() }}</span>
      </div>
    </div>

    @if (isLoggedIn | async) {
      <div class="flex items-center gap-2">
        <span class="hidden text-sm font-medium text-slate-600 md:inline">{{ (authUser | async)?.displayName }}</span>
        <button
          mat-icon-button
          type="button"
          aria-label="Benutzermenü öffnen"
          [matMenuTriggerFor]="userMenu"
          class="text-slate-600 hover:text-slate-800"
        >
          <fa-icon [icon]="icons.person"></fa-icon>
        </button>
        <a
          mat-icon-button
          class="text-slate-600 hover:text-slate-800"
          href="https://docs.gp2.app/"
          target="_blank"
          rel="noopener"
          aria-label="Hilfe öffnen"
        >
          <fa-icon [icon]="icons.help"></fa-icon>
        </a>
      </div>
    }
  </div>
</header>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item [routerLink]="['/change-password']">
    <fa-icon [icon]="icons.lock"></fa-icon>
    Passwort ändern
  </button>
  <button mat-menu-item (click)="logout()">
    <fa-icon [icon]="icons.logout"></fa-icon>
    Logout
  </button>
</mat-menu>
